
const rawAppEnv = import.meta.env.VITE_ENV || "";
// VersionBar only accepts dev, test, uat or prod; fall back to 'dev' for local/unset/unrecognized values.
export const appEnv          = ["dev", "test", "uat", "prod"].includes(rawAppEnv) ? rawAppEnv : "dev";
export const appVersionLabel = import.meta.env.VITE_VersionLabel ?? "";
export const appBuildLabel   = import.meta.env.VITE_BuildLabel ?? "";

let vendorsUrl = `https://goa-wdp-apim-external-dev.azure-api.net/wildfire-finance-api-dev/getVendor`;
if (appEnv === 'prod') {
    vendorsUrl = `https://apim.wildfireapps.alberta.ca/wildfire-finance-api/getVendor`;
} else if (appEnv === 'uat') {
    vendorsUrl = `https://goa-wdp-apim-uat.azure-api.net/wildfire-finance-api-uat/GetVendor`;
}
export { vendorsUrl };

export const apimUrl    = import.meta.env.VITE_APIM_URL ?? "";
export const appRealm   = import.meta.env.VITE_REALM ?? "";
export const appAuthUrl = import.meta.env.VITE_AUTHSERVERURL ?? "";


export const dateFormat = "YYYY-MM-DD";
export const tz = "America/Edmonton";
export const appResourceId = 'wildfire-admin-api';
export const roleManagerPermission = 'Adm_RoleManager_W';

export const gracePeriod = appEnv === 'prod' ? 7 :1;
export const appStrings = {
    
    validate_dt_invalid:'Date is invalid.',
    validate_dt_past:" This date cannot be in the past. it can be today or in the future.",
    
    validate_access_sdt_empty : 'Start date cannot be empty. Enter a date.',
    validate_access_sdt_beforeOrSameEdt : 'Start date must be before or the same as access end date.',
    validate_access_edt_todayOrLaterSdt : 'End date must be today or later than access start date.',


    validate_role_grant_sdt_empty:" Granted start date cannot be empty. enter a date.",
    validate_role_grant_sdt_beforeOrSameEdt: " Granted start date must be before or the same as granted end.",

    validate_role_grant_edt_todayOrFuture:" Granted end date must be today or in the future.",
    validate_role_grant_edt_laterThanSdt:" Granted end date must be later than start date."
    
}    

    

